import React from "react";
import "./styles/ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thank-you-container">
      <h3>
        <p>お問い合わせありがとうございます。</p>
        <p>返信は迷惑フォルダに送信されている場合があります。メールのご確認ができない場合、迷惑フォルダにアクセスしてみてください。</p>
        <p>資料請求の場合、ご記入のメールアドレスにリンクを送信しています。
        リンク先より、ダウンロードしてください。</p>
        <p>よろしくお願いします。</p>
        <p>Beta Japan Software</p>
      </h3>
    </div>
  );
};

export default ThankYou;
